import { createAuthServiceGa } from "./GAAuthService";

const authPlugin = {
  install(Vue, options) {
    var auth = createAuthServiceGa(options);

    Vue.prototype.$GAUserAuth = auth;
  }
};

export { authPlugin as default };
